import { createContext, useContext, useState, useEffect } from 'react';

const LanguageCtx = createContext({ lang: 'en', setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { const s = localStorage.getItem('sb-lang'); if (s) return s; } catch {}
    return 'en';
  });

  // IP-based detection (only if no saved preference)
  useEffect(() => {
    try { if (localStorage.getItem('sb-lang')) return; } catch {}
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(d => { if (d.country_code === 'KR') setLang('ko'); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    try { localStorage.setItem('sb-lang', lang); } catch {}
    // Add/remove class on html for font switching
    document.documentElement.classList.toggle('lang-ko', lang === 'ko');
  }, [lang]);

  return (
    <LanguageCtx.Provider value={{ lang, setLang }}>
      {children}
    </LanguageCtx.Provider>
  );
};

export const useLanguage = () => useContext(LanguageCtx);

/** Convenience hook: returns t(en, ko) function */
export const useTr = () => {
  const { lang } = useLanguage();
  return (en, ko) => lang === 'ko' ? ko : en;
};
